// extracted by mini-css-extract-plugin
module.exports = {"provider":"SGtJtj","isolate":"jp2o7x"};